<template>
  <v-card-text>
    <span>Lender Basic Information</span>
    <v-layout row wrap mr-4>
      <v-flex xs12 md5 pr-4>
        <v-text-field   :rules="[rules.Address]"  label="Address" v-model="lender.Address" :readonly="disableFields"></v-text-field>
      </v-flex>
      <v-flex xs12 md3 pr-4>
        <v-text-field   :rules="[rules.City]" label="City" v-model="lender.City" :readonly="disableFields"></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field   :rules="[rules.State]"  label="State" v-model="lender.State" :readonly="disableFields"></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field   :rules="[rules.Zip]"  label="Zip" v-model="lender.Zip" :readonly="disableFields"></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap mr-4>
      <v-flex xs12 md4 pr-4>
        <v-text-field   :rules="[rules.Phone]"  label="Phone" v-model="lender.Phone" :readonly="disableFields"></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field   :rules="[rules.Fax]" label="Fax" v-model="lender.Fax" :readonly="disableFields"></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field   :rules="[rules.Email]" label="Email" v-model="lender.Email" :readonly="disableFields"></v-text-field>
      </v-flex>
    </v-layout>
    <br />
    <br />
    <span>Loan Information</span>
    <v-layout row wrap mr-4>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          v-model="lender.OriginalLoanAmount"
          :rules="[rules.Balance]"
          :label="`Original Loan Balance`"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <date-picker
          label="Original Loan Date"
          v-model="lender.OriginalDateOfLoan"
          :rules="[rules.DateRequired]"
          :readonly="disableFields"
        ></date-picker>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          label="Interest Rate"
          v-model="lender.InterestRate"
          :rules="[rules.InterestRate]"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap mr-4>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          label="Academic Period Covered By Loan"
          v-model="lender.AcademicPeriodCoveredByLoan"
          :rules="[rules.AcademicPeriodCoveredByLoan]"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field  :rules="[rules.LoanTypeRequired]" label="Loan Type" v-model="lender.LoanType" :readonly="disableFields"></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          label="Loan Account Number"
          v-model="lender.LoanAccountNumber"
          :rules="[rules.required]"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-radio-group
          required
          :rules="[rules.IsThisaConsolidatedLoan]"
          row
          v-model="lender.IsThisaConsolidatedLoan"
          label="Is this a consolidated loan?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap mr-4>
      <v-flex xs12>
        <v-textarea
          label="Purpose of Loan Indicated on Application"
          v-model="lender.PurposerOfLoanIndicatedOnApplication"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap mr-4>
      <v-flex xs12>
        <v-radio-group
          row
          required
          :rules="[rules.WasTheLoanSold]"
          v-model="lender.WasTheLoanSold"
          :readonly="disableFields"
          label="Was the loan sold? (if you are not sure, check with your lender)"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex
        xs12
        v-if="lender.WasTheLoanSold"
        class="font-italic"
      >Please add an additional lender and complete the information for the lender the loan was sold to</v-flex>
    </v-layout>
    <v-layout row wrap mr-4>
      <v-flex xs12 md6>
        <v-radio-group
          row
          required
          :rules="[rules.IstheLoaninDefault]"
          v-model="lender.IstheLoaninDefault"
          label="Is the loan in default?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 md6 v-if="lender.IstheLoaninDefault==true">
        <date-picker
          label="Date of Default"
          v-model="lender.IfYesDateOfLoanDefault"
          :rules="[rules.DateRequired]"
          :disabled="disableFields"
        ></date-picker>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-radio-group
          row
          required
          :rules="[rules.IstheLoanUnderFederalCourtJudgement]"
          v-model="lender.IstheLoanUnderFederalCourtJudgement"
          label="Is the loan under a federal court judgment?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 md6 v-if="lender.IstheLoanUnderFederalCourtJudgement==true">
        <date-picker
          label="Date of Judgement"
          v-model="lender.IfYesDateOfJudgement"
          :rules="[rules.DateRequired]"
          :disabled="disableFields"
        ></date-picker>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-for="i in list" :key="i.ID">
      <v-flex xs12 md4 class="extra-pad">
        <v-layout row wrap>
          <v-tooltip bottom>
            <template slot="activator">
              <v-icon color="primary" @click="_view(i.Document.ID, 0)">visibility</v-icon>
            </template>
            <div>View Document</div>
          </v-tooltip>
          <v-tooltip bottom>
            <template slot="activator">
              <v-icon color="primary" @click="_view(i.Document.ID, 1)">save_alt</v-icon>
            </template>
            <div>Download Document</div>
          </v-tooltip>
          <v-text-field label="Name" :value="i.Document.Name" readonly></v-text-field>
        </v-layout>
      </v-flex>
      <v-flex xs12 md4 class="extra-pad">
        <v-text-field
          label="Added By"
          :value="`${i.Document.User.FirstName} ${i.Document.User.LastName}`"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4 class="extra-pad">
        <v-text-field label="Added On" :value="i.Document.AddedOn | formattedDate" readonly></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="lender.ID > 0">
      <v-flex xs12>
        <div class="dropbox">
          <input class="input-file" type="file" @change="getFiles" />
          <p
            v-if="uploadList.length == 0"
            class="extra-margin"
          >Drag file to upload or click to browse</p>
          <div v-if="uploadList.length > 0" class="extra-margin">
            <p class="uploadList" v-for="(item, index) in items" :key="index">{{item.name}}</p>
          </div>
        </div>
        <br />
        <v-btn color="primary" @click="_addDoc" :disabled="saving">Upload Files</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex
        xs12
        class="font-italic"
      >You will be able to upload related documents after saving the application.</v-flex>
    </v-layout>
  </v-card-text>
</template>

<script>
import Rules from '../../validation/rules'
import DatePickerVue from '../DatePicker.vue'
import LuLoanTypeVue from '../LuLoanType.vue'
export default {
  props: {
    lender: Object,
    disableFields: Boolean,
  },
  data() {
    return {
      list: this.lender.LoanDocuments,
      uploadList: [],
      items: [],
      saving: false,
      snackbar: false,
      errorText: '',
      rules: Rules,
    }
  },
  components: {
    'date-picker': DatePickerVue,
    'v-loan': LuLoanTypeVue,
  },
  methods: {
    _addDoc() {
      const self = this
      this.saving = true
      for (let i = 0; i < this.uploadList.length - 2; i++) {
        let file = this.uploadList[i]
        let fileReader = new FileReader()
        if (fileReader && file) {
          fileReader.readAsDataURL(file)
          fileReader.onload = function() {
            let contents = fileReader.result.split(',')[1]
            let obj = {
              Name: file.name,
              Type: file.type,
              LenderAndLoanInfoID: self.lender.ID,
              Contents: contents,
            }
            axios
              .post(`/Documents`, obj)
              .then(function(response) {
                self.list.push({DocumentID: response.data.ID, LenderAndLoanInfoID: self.lender.ID, Document: response.data})
              })
              .catch(function(error) {
                console.log(error)
                this.errorText = error.response.data
                this.snackbar = true
              })
          }
        }
      }
      this.saving = false
      this.uploadList = []
      this.items = []
    },
    _view(id, op) {
      let url = `Documents/${id}`
      axios
        .get(url)
        .then((response) => {
          let data = response.data
          let binary = atob(data.file.replace(/\s/g, ''))
          let len = binary.length
          let buffer = new ArrayBuffer(len)
          let view = new Uint8Array(buffer)
          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i)
          }
          let blob = new Blob([view], { type: data.doc.Type })
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, data.doc.Name)
          } else {
            if (op == 0) {
              //Will not work if AdBlock is running in Chrome
              let blobUrl = URL.createObjectURL(blob)
              window.open(blobUrl)
            } else {
              let blobUrl = URL.createObjectURL(blob)
              let a = document.createElement('a')
              a.href = blobUrl
              a.download = data.doc.Name
              document.body.appendChild(a)
              a.click()
              setTimeout(function() {
                document.body.removeChild(a)
                window.URL.revokeObjectURL(url)
              }, 0)
            }
          }
        })
        .catch((e) => {
          console.log(e)
          this.errorText = e.response.data
          this.snackbar = true
        })
    },
    getFiles: function(event) {
      this.uploadList = []
      for (let file in event.target.files) {
        this.uploadList.push(event.target.files[file])
      }
      for (let i = 0; i < this.uploadList.length - 2; i++) {
        if (this.uploadList[i].name) this.items.push(this.uploadList[i])
      }
    },
  },
  watch: {
    'lender.LoanDocuments': {
      handler(val) {
        this.list = []
        this.list = val
      },
    },
  },
}
</script>

<style>
.dropbox {
  outline: 2px dashed rgb(190, 190, 190); /* the dash box */
  outline-offset: -10px;
  background: #fafafa;
  color: dimgray;
  padding: 10px 10px;
  position: relative;
  cursor: pointer;
  /* width: 20%; */
  height: 100px;
  /* margin-left: auto;
  margin-right: auto;  */
  margin-top: 10px;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 100px;
  position: absolute;
  cursor: pointer;
}

</style>
